const MAP_COLOR = {
    TEAM_COLORS: [
        '#DC2626',
        '#9E6EE6',
        '#72A1E8',
        '#82D5EB',
        '#72E361',
        '#E4AC71',
        '#B7306E',
        '#1F498C',
        '#622ABF',
        '#FDE047',
    ],
    TEAM_UNASSIGNED: '#808080',
    POLYGON_ASSIGNED: '#008B33',
    POLYGON_UNASSIGNED: '#8430B7',
    POLYGON_DEACTIVATED: '#4a4a4a',
    POLYGON_SELECTED: '#f5cb42',
};
export default MAP_COLOR;
